import http from "services/http";

export interface ExchangeRateConfig {
  usd_ngn_rate?: number;
  esim_markup_percent?: number;
}

// The response shape isn't documented; accept the fields at `data` or one level down.
const pickConfig = (data: any): ExchangeRateConfig => {
  const src = data?.config ?? data?.exchange_rate ?? data ?? {};
  const num = (v: any) => (v === undefined || v === null || v === "" ? undefined : Number(v));
  return {
    usd_ngn_rate: num(src.usd_ngn_rate),
    esim_markup_percent: num(src.esim_markup_percent),
  };
};

export const getExchangeRate = async (): Promise<ExchangeRateConfig> => {
  const response = await http.get("/admin/exchange-rate");
  return pickConfig(response.data?.data);
};

// Send only the fields that changed; both are optional on the backend.
export const updateExchangeRate = async (body: ExchangeRateConfig) => {
  const response = await http.put("/admin/exchange-rate", body);
  return response.data;
};
